/* eslint no-shadow: ["error", { "allow": ["state", "getters"] }] */
import {
  db,
  firebase,
  firebaseAuth,
  usersCollection,
} from '../../../firebase'

const state = {
  currentCustomer: {},
  verificationId: '',
  customer: null,
  customers: [],
  totalCustomerCounts: 0,
  dailyCustomerCounts: 0,
  monthlyCustomerCounts: 0,
}

const isEmpty = obj => [Object, Array].includes((obj || {}).constructor) && !Object.entries((obj || {})).length

const getters = {
  customer: state => state.customer,
  customers: state => state.customers,
  verificationId: state => state.verificationId,
  totalCustomerCounts: state => state.totalCustomerCounts,
  dailyCustomerCounts: state => state.dailyCustomerCounts,
  monthlyCustomerCounts: state => state.monthlyCustomerCounts,
}

const mutations = {
  customerCounts: (state, { total, daily, monthly }) => {
    if (total) {
      // yes
    } else if (daily) {
      state.dailyCustomerCounts = daily
    } else if (monthly) {
      state.monthlyCustomerCounts = monthly
    }
  },
  customerStatus: (state, customer) => {
    const keys = [
      'fullName',
      'email',
      'language',
      'phoneNumber',
      'photoURL',
      'updateAt',
      'createAt',
      'claims',
      'uid',
      'id',
    ]

    Object.keys(customer).forEach(key => {
      const value = customer[key]
      if (keys.indexOf(key) !== -1 && value !== 'undefined' && value !== null) {
        state.currentCustomer[key] = value
      }
    })
  },
  setVerificationId: (state, verificationId) => {
    state.verificationId = verificationId
  },
  addCustomers: (state, customers) => {
    if (customers && customers.constructor === Array) {
      if (customers.add) {
        state.customers = [...state.customers, ...customers]
      } else {
        state.customers = customers
      }
    } else if (typeof customers === 'object' && !isEmpty(customers)) {
      state.customer = customers
    }
  },
  deleteCustomerfromCustomers: (state, { key, value }) => {
    const removeIndex = state.customers.map(item => item[key]).indexOf(value)
    state.customers.splice(removeIndex, 1)
  },
}

const actions = {
  getDailyCustomerCounts: async ({ commit }, { date, uid }) => {
    // date format YYYY-MM-DD
    if (date && uid) {
      const start = new Date(date)
      const end = new Date(date)
      end.setDate(end.getDate() + 1)

      const totalCustomers = db.collectionGroup('totalCustomers')
        .where('uid', '==', uid)
        .where('updateAt', '>=', start)
        .where('updateAt', '<', end)
        .orderBy('updateAt', 'desc')

      await totalCustomers.get().then(async snapshot => {
        if (snapshot.empty) {
          // do something
        } else {
          let customerCounts = 0
          await snapshot.forEach(doc => {
            customerCounts += doc.data().customerCounts
          })
          commit('customerCounts', { daily: customerCounts })
        }
      })
    }
  },
  getMonthlyCustomerCounts: async ({ commit }, { date, uid }) => {
    // TODO: Need a cron
    // date format YYYY-MM-DD
    if (date && uid) {
      const d = new Date(date)
      const start = new Date(d.getFullYear(), d.getMonth(), 1)
      const end = new Date(d.getFullYear(), d.getMonth() + 1, 1)
      end.setDate(end.getDate() + 1)

      const totalRecords = db.collectionGroup('totalCustomers')
        .where('uid', '==', uid)
        .where('updateAt', '>=', start)
        .where('updateAt', '<', end)
        .orderBy('updateAt', 'desc')

      await totalRecords.get().then(async snapshot => {
        if (snapshot.empty) {
          // do something
        } else {
          let customerCounts = 0
          await snapshot.forEach(doc => {
            customerCounts += doc.data().customerCounts
          })
          commit('customerCounts', { monthly: customerCounts })
        }
      })
    }
  },
  createCustomer: async ({ dispatch }, params) => {
    await dispatch('fetchCustomer', { cuid: params.campaign.cuid, uid: params.uid })
      .then(customer => {
        if (!customer) {
          let search = [params.user.email, params.user.phoneNumber, params.user.fullName]
          search = search.filter(n => n)

          const data = {
            fullName: params.user.fullName,
            email: params.user.email,
            language: params.user.langauge,
            phoneNumber: params.user.phoneNumber,
            photoURL: params.user.photoURL,
            claims: params.user.claims,
            cid: params.cid,
            campaign: params.campaign,
            search: firebase.firestore.FieldValue.arrayUnion(...search),
            records: {
              totalRecords: 1,
              lastVisit: firebase.firestore.FieldValue.serverTimestamp(),
            },
          }

          const time = {
            createAt: firebase.firestore.FieldValue.serverTimestamp(),
            updateAt: firebase.firestore.FieldValue.serverTimestamp(),
          }
          usersCollection.doc(params.campaign.cuid).collection('customers').doc(params.uid)
            .set({ ...data, ...time })
            .then(() => {
              localStorage.setItem(`${params.campaign.cuid}${params.uid}`, JSON.stringify({ ...data, uid: params.uid }))
              dispatch('incrementCounter', {
                ref: usersCollection.doc(params.campaign.cuid),
                col: 'customerCounts',
                doc: 'totalCustomers',
                uid: params.campaign.cuid,
              })
            })
        } else {
          const update = {
            totalRecords: 1,
            lastVisit: firebase.firestore.FieldValue.serverTimestamp(),
          }
          usersCollection.doc(params.campaign.cuid).collection('customers').doc(params.uid)
            .update({ records: update })
        }
      })
  },
  fetchCustomer: (ctx, { cuid, uid }) => new Promise((resolve, reject) => {
    if (uid && cuid) {
      const key = `${cuid}${uid}`
      if (0 && !isEmpty(localStorage.getItem(key))) {
        resolve(JSON.parse(localStorage.getItem(key)))
      } else {
        usersCollection.doc(cuid).collection('customers').doc(uid).get()
          .then(snapshot => {
            if (snapshot && snapshot.exists) {
              localStorage.setItem(key, JSON.stringify({ ...snapshot.data(), uid }))
              resolve({ ...snapshot.data(), uid })
            } else {
              resolve(null)
            }
          })
          .catch(error => {
            reject(error)
          })
      }
    } else {
      reject()
    }
  }),
  deleteCampaignCustomer: async ({ commit, getters }, { uid, id }) => {
    if (uid && id) {
      await usersCollection.doc(uid).collection('customers').doc(id).delete()
        .then(() => {
          commit('deleteCustomerfromCustomers', { key: 'id', value: id })
          return getters.customers
        })
    }
  },
  fetchCampaignCustomer: async ({ commit }, { cuid, uid }) => {
    if (uid && cuid) {
      await usersCollection.doc(cuid).collection('customers').doc(uid).get()
        .then(snapshot => {
          if (snapshot && snapshot.exists) {
            commit('addCustomers', { ...snapshot.data(), uid })
          }
        })
    }
  },
  fetchCustomers: async ({ commit }, params) => new Promise((resolve, reject) => {
    let uid = (params && params.uid) ? params.uid : ''

    if (isEmpty(uid)) {
      const firebaseUser = firebaseAuth.currentUser
      uid = firebaseUser.uid

      if (isEmpty(uid)) {
        const error = {
          code: '',
          message: '',
        }
        reject(error)
      }
    }

    usersCollection.doc(uid).collection('customers')
      .get()
      .then(snapshot => {
        const customers = []
        snapshot.forEach(doc => {
          customers.push({ ...doc.data(), ...{ id: doc.id } })
        })
        commit('addCustomers', customers)
        resolve(customers)
      })
      .catch(err => {
        reject(err)
      })
  }),
}

export default {
  state,
  mutations,
  getters,
  actions,
}
